<div class="row">
  <div class="col-sm-6">
    <app-card [cardOptionBtnValue]="'global.new_order'|translate "  [cardOptionBtn]="true" [cardRouterLink]="'/dealer-system/order/add'"  [title]="'admin.order.successful.title'|translate">
      <p>
        {{'admin.order.successful.description'|translate}}
      </p>
      <h5 class="mb-4">{{'admin.order.successful.order_detail'|translate}} :</h5>
      <div class="row">
        <div class="col-md-3">
          <p> {{'doctrine.order.reference'|translate}}:</p>
        </div>
        <div class="col-md-8">
         <p>{{order.reference}}</p>
        </div>
        <div class="col-md-3">
          <p>  {{'doctrine.order.order_date'|translate}}:</p>
        </div>
        <div class="col-md-8">
          {{order.created | DateFormat: 'kk:mm'}}
        </div>
        <div class="col-md-3">
          <p> {{'doctrine.order.order_number'|translate}}:</p>

        </div>
        <div class="col-md-8" *ngIf="order.splitOrders.length !== 0">
          <p class="mb-0" *ngFor="let orderSplit of order.splitOrders">
            {{orderSplit.orderNo}}
            <a (click)="downloadOrderPdf(orderSplit.id)">
              (order pdf)
            </a>
          </p>
        </div>
        <div class="col-md-8" *ngIf="order.splitOrders.length === 0">
          <p class="mb-0" *ngIf="order.orderNo">
            {{order.orderNo}}
            <a (click)="downloadOrderPdf(order.id)">
              (order pdf)
            </a>
          </p>
        </div>
      </div>
    </app-card>
  </div>
  <div class="col-sm-6">
    <app-card [title]="'admin.order.successful.order_email.title'|translate">
      <p>
        {{'admin.order.successful.order_email.description'|translate}}
      </p>
      <form class="edit-form" #emailFrom="ngForm" novalidate>
        <div class="form-group row">
          <div class="col-sm-4">
            <label class="float-label">{{'doctrine.user.email'|translate}} <span class="star">*</span>
            </label>
            <input type="text" name="emailItem" #emailItem="ngModel" [(ngModel)]="email" email
                   class="form-control" required>
            <div class="messages text-danger"
                 *ngIf="emailItem.invalid && emailItem.dirty && emailItem.errors?.required">
              {{'errors.required'|translate}}
            </div>
            <div class="messages text-danger"
                 *ngIf="emailItem.invalid && emailItem.dirty && emailItem.errors?.email">
              {{'errors.invalid'|translate}}
            </div>
          </div>
        </div>
      </form>
      <div class="mt-3">
        <button (click)="sendOrderEmail()" [disabled]="!emailFrom.valid" class="btn btn-primary ripple light" type="button">
          {{'global.email_order'|translate}}
        </button>
      </div>
    </app-card>
  </div>
</div>

<app-modal-basic #pdfModal [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h4 class="modal-title">{{'admin.order.order_pdf.modal.title'|translate}}</h4>
    <button type="button" class="close basic-close" (click)="pdfModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <div class="col-lg-12" style="text-align: center">
      <a class="btn btn-success" href="{{pdfLink}}" target="_blank">{{"admin.order.order_pdf.modal.pdf_link" |translate}}</a>
    </div>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-default ripple" (click)="pdfModal.hide()">{{'global.cancel'|translate}}</button>
  </div>
</app-modal-basic>

<a #downloadLink href="" download style="display: none"></a>
